<template>
 <modal v-model="open" class="my-sciserver-modal-dialog" title="Support Links" size="sm" auto-focus>
  <div class="container-fluid">
          <div class="row">
            <div class="col-md-9">
              <a href="http://www.sciserver.org/support/help/" title="Go to User Guide" rel="noopener" target="_blank" style=" text-decoration: underline; font-size: 14px;">User guides</a>
              <br>
              <a href="http://www.sciserver.org/support/documentation/" title="Go to API Documentation" rel="noopener" target="_blank" style=" text-decoration: underline; font-size: 14px;">API documentation</a>
              <br>
              <a href="mailto:sciserver-helpdesk@jhu.edu" title="Email to help desk" style=" text-decoration: underline; font-size: 14px;">Help desk</a>
              <br>
              <a href="http://www.sciserver.org/support/bug-report-and-suggestion-form/" title="Report Bug" rel="noopener" target="_blank" style=" text-decoration: underline; font-size: 14px;">Bug report form</a>
            </div>
          </div>
        </div>
    <div slot="footer">
        <button type="button" class="btn btn-default" @click="open = false"  data-action="auto-focus">Close</button>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'supportDialog',
  computed: {},
  data: () => ({
    open: false,
  }),
  methods: {
    startDialog() {
      this.open = true;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/userSettingsComponents/supportDialog.vue